const DailyPuzzleIcon: React.FC = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20 13.06H19.87V10H2V13.06H2.11C3.47 13.06 4.58 14.17 4.58 15.53V15.99C4.58 17.35 3.47 18.46 2.11 18.46H2V20.53C2 21.89 3.11 23 4.47 23H8.74V22.48C8.74 21.12 9.85 20.01 11.21 20.01H11.67C13.03 20.01 14.14 21.12 14.14 22.48V23H17.41C18.77 23 19.88 21.89 19.88 20.53V18.46H20.01C21.37 18.46 22.48 17.35 22.48 15.99V15.53C22.48 14.17 21.37 13.06 20.01 13.06H20Z"
            fill="#CBCBCB"
        />
        <path
            d="M20 11.06H19.87V9H2V11.06H2.11C3.47 11.06 4.58 12.17 4.58 13.53V13.99C4.58 15.35 3.47 16.46 2.11 16.46H2V18.53C2 19.89 3.11 21 4.47 21H8.74V20.48C8.74 19.12 9.85 18.01 11.21 18.01H11.67C13.03 18.01 14.14 19.12 14.14 20.48V21H17.41C18.77 21 19.88 19.89 19.88 18.53V16.46H20.01C21.37 16.46 22.48 15.35 22.48 13.99V13.53C22.48 12.17 21.37 11.06 20.01 11.06H20Z"
            fill="#E8E8E8"
        />
        <path
            d="M19.87 6.19977C19.87 5.57977 19.68 4.99977 19.37 4.50977C18.87 4.19977 18.28 4.00977 17.65 4.00977H6.22C4.44 4.00977 3 5.43977 3 7.20977V9.00977H19.87V6.20977V6.19977Z"
            fill="#B23A38"
        />
        <path
            d="M6.22 4H17.65C18.29 4 18.87 4.19 19.37 4.5C18.8 3.6 17.8 3 16.65 3H5.22C3.44 3 2 4.43 2 6.2V9H3V7.2C3 5.43 4.44 4 6.22 4Z"
            fill="#DA5457"
        />
        <path
            d="M7 8.41992C8.10457 8.41992 9 7.52449 9 6.41992C9 5.31535 8.10457 4.41992 7 4.41992C5.89543 4.41992 5 5.31535 5 6.41992C5 7.52449 5.89543 8.41992 7 8.41992Z"
            fill="#6B100F"
        />
        <path d="M8 2C8 1.45 7.55 1 7 1C6.45 1 6 1.45 6 2V6C6 6.55 6.45 7 7 7V3C7 2.45 7.45 2 8 2Z" fill="#575757" />
        <path d="M8 6V2C7.45 2 7 2.45 7 3V7C7.55 7 8 6.55 8 6Z" fill="#3A3A3A" />
        <path
            d="M14.8701 8.41992C15.9747 8.41992 16.8701 7.52449 16.8701 6.41992C16.8701 5.31535 15.9747 4.41992 14.8701 4.41992C13.7655 4.41992 12.8701 5.31535 12.8701 6.41992C12.8701 7.52449 13.7655 8.41992 14.8701 8.41992Z"
            fill="#6B100F"
        />
        <path
            d="M15.8701 2C15.8701 1.45 15.4201 1 14.8701 1C14.3201 1 13.8701 1.45 13.8701 2V6C13.8701 6.55 14.3201 7 14.8701 7V3C14.8701 2.45 15.3201 2 15.8701 2Z"
            fill="#575757"
        />
        <path d="M15.8701 6V2C15.3201 2 14.8701 2.45 14.8701 3V7C15.4201 7 15.8701 6.55 15.8701 6Z" fill="#3A3A3A" />
        <path d="M19.87 9H2V10H19.87V9Z" fill="#CBCBCB" />
    </svg>
)

DailyPuzzleIcon.displayName = 'DailyPuzzleIcon'

export default DailyPuzzleIcon
